/**
 * views/projects/tableBits.jsx - the Projects table's small module-level
 * pieces (its header / body cells, the engineer-name splitter, the default
 * sort, blank-or-number). Moved out of ProjectsView.jsx.
 */
import { Th as BidTh, Td as BidTd } from '../../components/ui/BidTablePrimitives';

const Th = (props) => <BidTh variant="projects" sticky {...props} />;
const Td = (props) => <BidTd pad="px-3 py-1.5" {...props} />;
/** "Ian,  Laith" -> ['Ian', 'Laith']: the names in a comma-separated engineer field. */
const splitNames = (v) =>
  String(v == null ? '' : v)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
const DEFAULT_SORT = { col: 'quoteDate', dir: 'desc' };
const blankOr = (v) => (v == null || v === '' ? null : Number(v));

export { Th, Td, splitNames, DEFAULT_SORT, blankOr };
